/**
 * Forms methods mixin
 */

export default {
  props: {
    displayGrid: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setErrorVisible (msg = '') {
      this.displayError = true
      this.errorMessage = msg
    },
    hideErrors () {
      this.displayError = false
    }
  },
  computed: {
    getLabelClass () {
      return this.required ? 'label required' : 'label'
    },
    getInputColClass () {
      return 'offset-md-1 col-md-7'
    },
    getColClass () {
      if (this.faClass) {
        return 'col-10'
      } else {
        return 'col-12'
      }
    }
  }
}
